import React from 'react';
import masterSlideLoader from '../utilities/masterSlideLoader';
import { Bar, BarLabel } from '../components/gagebar/bar';

//マスタービューの遷移用のサンプルファイル
//MasterSampleView1 でパラメータをエンコードして次のページへ遷移
//MasterSampleView2 でパラメータをデコードして、パラメータの持つprev_idで前の画面に戻る
//MasterSampleView2でブラウザリロードしても前の画面に戻れるようになってる

export class MasterSampleView1 extends React.Component {
  constructor(props) {
    super(props);
  }

  move() {
    //MasterSlideLoader内で画面を遷移しする場合に、
    //urlに戻る際のパラメータも必要になるので、エンコードして渡す
    const param = {
      id: 0,
      prev_id: 2,
    };
    const json = encodeURIComponent(JSON.stringify(param));
    masterSlideLoader.show('MasterSampleView2', { state: { id: json } });
  }

  render() {
    return (
      <div className='contruction-slide-view show'>
        <div className='contruction-slide-view__view'>
          <div className='contruction-slide-view__header'>
            <div className='contruction-slide-view__title'>
              <div
                style={{
                  position: 'absolute',
                  zIndex: 1,
                  width: '100%',
                  height: '100%',
                }}
              >
                <h1>マスター1</h1>
                <button
                  onClick={e => {
                    this.move(e);
                  }}
                >
                  次へ
                </button>
                <button
                  onClick={() => {
                    masterSlideLoader.close();
                  }}
                >
                  閉じる
                </button>
              </div>
            </div>
          </div>
          <div className='contruction-slide-view__body'>
            <table className='table'>
              <thead className='table__header'>
                <tr className='table__label'>
                  <td
                    id='value-table--gate-schedule'
                    className='value-table value-table--table__label'
                  >
                    <BarLabel
                      fieldWorkStartTime='510'
                      fieldWorkEndTime='1170'
                    />
                  </td>
                </tr>
              </thead>
              <tbody className='table__group show'>
                <tr className='table__item table__item--gate-schedule-table'>
                  <td className='value-table value-table--gate-schedule'>
                    <Bar
                      type='gage--carryin'
                      grid='15'
                      workStartTime='8:30'
                      workEndTime='19:30'
                      startTime='12:00'
                      endTime='15:00'
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export class MasterSampleView2 extends React.Component {
  constructor(props) {
    super(props);

    //パラメータ
    const param = JSON.parse(decodeURIComponent(props.view.state.id));
    this.state = {
      prev_id: param.id,
    };
  }
  componentDidMount() {}

  move() {
    masterSlideLoader.show('MasterSampleView1', {
      state: { id: this.state.prev_id },
    });
  }

  render() {
    return (
      <div className='contruction-slide-view show'>
        <div className='contruction-slide-view__view'>
          <div className='contruction-slide-view__header'>
            <div className='contruction-slide-view__title'>
              <div
                style={{
                  position: 'absolute',
                  zIndex: 1,
                  width: '100%',
                  height: '100%',
                }}
              >
                <h1>マスター2</h1>
                <button
                  onClick={e => {
                    this.move(e);
                  }}
                >
                  戻る
                </button>
                <button
                  onClick={() => {
                    masterSlideLoader.close();
                  }}
                >
                  閉じる
                </button>
              </div>
            </div>
          </div>
          <div className='contruction-slide-view__body' />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/MasterSampleView.jsx